import i, { css as t } from "styled-components";
import { Button as a } from "../../Inputs/Button/Button.es.js";
const n = {
  success: "var(--color-accent-primary-strong)",
  warning: "var(--color-warning-strong)",
  error: "var(--color-error-default)",
  info: "var(--color-info-strong)"
}, e = {
  success: "var(--color-accent-primary-weakest)",
  warning: "var(--color-warning-weakest)",
  error: "var(--color-error-weakest)",
  info: "var(--color-info-weakest)"
}, d = i.div.withConfig({
  displayName: "Notification",
  componentId: "sc-zzb8gg-0"
})(["border-radius:var(--size-border-radius-md);display:flex;gap:8px;padding:8px;text-align:left;width:", ";", ""], ({
  $size: o
}) => o || "100%", ({
  $status: o
}) => t(["background-color:", ";border:1px solid ", ";border-left-width:0.4rem;"], e[o], n[o]));
var r;
const g = i.div.withConfig({
  displayName: "NotificationBody",
  componentId: "sc-zzb8gg-1"
})(["flex-grow:1;padding-top:1px;", "{margin-top:2px;}"], (r = a.S) == null ? void 0 : r.Button);
export {
  d as Notification,
  g as NotificationBody
};
//# sourceMappingURL=style.es.js.map
